import Vue from 'vue';
import VueRouter from 'vue-router';
import store from './store/store';import deliveryData  from "./assets/data/deliveryData";
import LoginPage from './pages/login.vue';
import ForgotPasswordPage from './pages/forgot.vue';
import ResetPasswordPage from './pages/reset.vue';
import VerifyPage from './pages/verify.vue';
import AssetsPage from './pages/assets.vue';
import IndoorAssetsPage from './pages/indoor-assets.vue';
import SettingsPage from './pages/configuration/settings.vue';
import SitesPage from './pages/configuration/sites.vue';
import ThemingPage from './pages/configuration/theming.vue';
import UsersPage from './pages/configuration/users.vue';
import WorkflowPage from './pages/configuration/workflows.vue';
import ReportsPage from './pages/configuration/reports.vue';
import HealthPage from './pages/configuration/health.vue';
import SearchPage from './pages/configuration/search.vue';
import WifiOverrides from './pages/configuration/wifi-overrides.vue';
import OrganizationSelect from './pages/organization-select.vue';
import AppsCards from './pages/apps-cards.vue';
import EulaPage from './pages/eula.vue';
import DashboardPage from './pages/dashboard.vue';
import KibanaPage from './pages/kibana.vue';
import TableauPage from './pages/tableau.vue';
import HelpPage from './pages/help.vue';
import InstallPage from './pages/install.vue';
import SLAPage from './pages/configuration/sla.vue';
import AddFloorplan from './pages/add-floorplan.vue';
import SubscriptionsPage from './pages/configuration/subscriptions.vue';
import Geofences from './pages/geofences.vue';
import MyPreferencesPage from './pages/my-preferences.vue';
const SetupPage = () => import('./pages/configuration/setup.vue');

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: LoginPage,
  },
  {
    path: '/forgot',
    component: ForgotPasswordPage,
  },
  {
    path: '/resetpassword',
    component: ResetPasswordPage,
  },
  {
    path: '/verify',
    component: VerifyPage,
  },
  {
    path: '/eula',
    meta: { title: 'sidebar-eula' },
    component: EulaPage,
  },
  {
    path: '/org-select',
    meta: { layout: 'no-org-layout', title: 'sidebar-org-select', menuItems: 'noOrgSidebarMenu' },
    component: OrganizationSelect,
  },
  {
    path: '/apps',
    meta: { layout: 'no-org-layout', title: 'sidebar-apps-cards', menuItems: 'appsSidebarMenu' },
    component: AppsCards,
  },
  {
    path: '/search',
    meta: { layout: 'no-org-layout', title: 'sidebar-settings-search', menuItems: 'noOrgSidebarMenu' },
    component: SearchPage,
  },
  {
    path: '/assets',
    meta: {
      layout: 'full-layout',
      title: 'sidebar-assets',
      headerSites: true,
      headerAreas: true,
      headerToggle: true,
    },
    component: AssetsPage,
  },
  {
    path: '/my-preferences',
    meta: {
      layout: 'full-layout',
      title: 'my-preferences-title',
      headerSites: false,
      headerAreas: false,
      headerToggle: false,
    },
    component: MyPreferencesPage,
  },
  {
    path: '/indoor-assets',
    meta: {
      layout: 'full-layout',
      title: 'sidebar-assets-indoor',
      headerSites: true,
      headerAreas: true,
      headerToggle: true,
    },
    component: IndoorAssetsPage,
  },
  {
    path: '/configuration/subscriptions',
    meta: {
      layout: 'full-layout',
      title: 'subscriptions',
      headerSites: false,
      headerAreas: true,
      headerToggle: true,
    },
    component: SubscriptionsPage,
  },
  {
    path: '/configuration/sites',
    meta: { layout: 'full-layout', title: 'sidebar-settings-sites' },
    component: SitesPage,
  },
  {
    path: '/devices/settings',
    meta: {
      layout: 'full-layout',
      title: 'sidebar-supertag-settings',
      headerSites: true,
    },
    component: SettingsPage,
  },
  {
    path: '/configuration/theming',
    meta: { layout: 'full-layout', title: 'sidebar-settings-theming' },
    component: ThemingPage,
  },
  {
    path: '/configuration/users',
    meta: {
      layout: 'full-layout',
      title: 'sidebar-settings-basic-users',
      headerSites: true,
    },
    component: UsersPage,
  },
  {
    path: '/events/workflows',
    meta: {
      layout: 'full-layout',
      title: 'sidebar-settings-workflows',
      headerSites: true,
    },
    component: WorkflowPage,
  },
  {
    path: '/events/reports',
    meta: { layout: 'full-layout', title: 'sidebar-settings-reports', headerSites: true },
    component: ReportsPage,
  },
  {
    path: '/devices/health',
    meta: { layout: 'full-layout', title: 'sidebar-settings-health', headerSites: true },
    component: HealthPage,
  },
  {
    path: '/devices/search',
    meta: { layout: 'full-layout', title: 'sidebar-settings-search', headerSites: false },
    component: SearchPage,
  },
  {
    path: '/devices/setup',
    meta: { layout: 'full-layout', title: 'sidebar-settings-setup', headerSites: true },
    component: SetupPage,
  },
  {
    path: '/dashboard',
    meta: {
      layout: 'full-layout',
      title: 'sidebar-dashboard',
      headerSites: true,
    },
    component: DashboardPage,
  },
  {
    path: '/sla',
    meta: {
      layout: 'full-layout',
      title: 'sidebar-sla',
      headerSites: true,
    },
    component: SLAPage,
  },
  {
    path: '/kibana',
    meta: {
      layout: 'full-layout',
      headerSites: false,
    },
    component: KibanaPage,
  },
  {
    path: '/install',
    meta: { 
      layout: 'full-layout', 
      title: 'sidebar-install', 
      headerSites: true 
    },
    component: InstallPage,
  },
  {
    path: '/analytics/:view',
    name: 'tableau',
    meta: {
      layout: 'full-layout',
      noHeader: true,
      sidebarMini: 'MD_VIEWPORT'
    },
    component: TableauPage,
  },
  {
    path: '/help',
    meta: { layout: 'full-layout', title: 'sidebar-help', headerSites: false },
    component: HelpPage,
  },
  {
    path: '/geofences',
    meta: { layout: 'full-layout', title: 'geofences', headerSites: true },
    component: Geofences,
  },
  {
    path: '/add-floorplan',
    meta: {
      layout: 'full-layout',
      headerSites: false,
    },
    component: AddFloorplan,
  },
  {
    path: '/configuration/wifi-overrides',
    name: 'wifi-overrides',
    meta: {
      layout: 'full-layout',
      title: 'wifiOverrides.title',
      requiresAuth: true,
      section: 'configuration',
      helpUrl: 'https://knowledge.link-labs.com/LinkLabsKowledgeBase/Features/How+to+Use+the+Wifi+Override+Feature',
      helpTooltip: 'View WiFi Location Override User Guide',
    },
    component: () => import('@/pages/configuration/wifi-overrides.vue'),
  },
  {
    path: '/*',
    redirect: '/assets',
  },
];

const userHasAccess =  (path) => {
  // TODO here we need to check if the loggedUser has access to that path
  if(path === '/apps'){
    if(deliveryData.deliveryOrgsIds.includes(store.getters['organization/orgSelected'])){
      return true;
    }else{
      return false;
    }
  }else{
    return true;
  }
}

const router = new VueRouter({ mode: 'history', routes });

const resolveDashboardRedirect = (dash) => {
  if (dash === 'analytics') {
    return '/dashboard';
  } else if (dash === 'assets/map') {
    return '/assets';
  } else if (dash === 'assets/summary') {
    return '/assets';
  } else if (dash === 'assets/list') {
    return '/assets';
  }
  return '/assets';
}

router.beforeEach(async (to, _, next) => {
  // to show full layout on organization page 
  if(store.getters['organization/orgSelected'] && to.path === '/org-select'){
    to.meta.menuItems = 'sidebarMenu'
  }
  // todo: find a better way to do this
  // allow these 3 routes to be always accessible
  if (window && window.ga) {
    //Google Analytics
    window.ga('send', 'pageview', to.path);
  }
  if (
    to.path !== '/forgot' &&
    to.path !== '/resetpassword' &&
    to.path !== '/verify'
  ) {
    if (to.path !== '/') {
      //internal pages
      if (store.getters.getUserLogged && userHasAccess(to.path)) {
        // Role-based route gating
        const required = to.meta && to.meta.requiredRoles;
        if (Array.isArray(required) && required.length > 0) {
          const userRoleObj = store.getters['organization/userRole'];
          const currentRole = userRoleObj && userRoleObj.assetInfo && userRoleObj.assetInfo.metadata && userRoleObj.assetInfo.metadata.props && userRoleObj.assetInfo.metadata.props.role;
          if (!currentRole || !required.includes(currentRole)) {
            return next('/assets'); // redirect non-admins to assets page
          }
        }
        return next();
      } else {
        return next('/');
      }
    } else {
      //login page
      if (store.getters.getUserLogged) {
        try {
          const prefsLoaded = store.getters['preferences/loaded'];
          if (!prefsLoaded) {
            await store.dispatch('preferences/loadMePreferences');
          }
        } catch (e) {
          // ignore; fallback to org-selected dashboard
        }

        try {
          const sitesLoaded = store.getters['site/sitesLoaded'];
          if (!sitesLoaded) {
            await store.dispatch('site/getSites');
          }
        } catch (e) {
          // ignore; analytics capability will be treated as unavailable
        }

        const analyticsEnabled =
          store.getters['organization/currentOrganization']?.isOrgCustomReportsEnable === true &&
          store.getters['site/currentSite']?.isCustomReportsEnable === true;

        const userDash = store.getters['preferences/defaultHomePage'];
        const orgDash = store.getters['organization/orgSelectedDashboard'];
        let dash = userDash || orgDash;
        if (dash === 'analytics' && !analyticsEnabled) {
          dash = 'assets/list';
        }
        return next(resolveDashboardRedirect(dash));
      }
    }
  }
  return next();
});

export default router;
